import { render, staticRenderFns } from "./MainObjects.vue?vue&type=template&id=0d52adb6&scoped=true&"
import script from "./MainObjects.vue?vue&type=script&lang=js&"
export * from "./MainObjects.vue?vue&type=script&lang=js&"
import style0 from "./MainObjects.vue?vue&type=style&index=0&id=0d52adb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52adb6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsCarouselFuturesCategories: require('/web/components/objects/CarouselFuturesCategories.vue').default,MainShowMoreBtn: require('/web/components/MainShowMoreBtn.vue').default})
